import { render, staticRenderFns } from "./DeactivateComplete.vue?vue&type=template&id=23c8b34e&scoped=true"
import script from "./DeactivateComplete.vue?vue&type=script&lang=js"
export * from "./DeactivateComplete.vue?vue&type=script&lang=js"
import style0 from "./DeactivateComplete.vue?vue&type=style&index=0&id=23c8b34e&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c8b34e",
  null
  
)

export default component.exports